// Web mock for react-native-device-info
const DeviceInfo = {
  getVersion: () => '1.0.0',
  getBuildNumber: () => '1',
  getSystemName: () => 'Web',
  getSystemVersion: () => navigator.userAgent,
  getModel: () => 'Web Browser',
  getDeviceId: () => 'web',
  getUniqueId: async () => 'web-' + Math.random().toString(36).substr(2, 9),
  getUniqueIdSync: () => 'web-unique',
  getBrand: () => 'Web',
  getManufacturer: async () => 'Web',
  isEmulator: async () => false,
  isEmulatorSync: () => false,
  getApplicationName: () => 'Conecta Brasal',
  getBundleId: () => 'com.conecta.brasal',
  getDeviceName: async () => 'Web Browser',
  getDeviceNameSync: () => 'Web Browser',
  getUserAgent: async () => navigator.userAgent,
  getUserAgentSync: () => navigator.userAgent,
  getBaseOs: async () => 'Web',
  getBaseOsSync: () => 'Web',
  hasNotch: () => false,
  getApiLevel: async () => 0,
  getApiLevelSync: () => 0,
  getFirstInstallTime: async () => 0,
  getFirstInstallTimeSync: () => 0,
  getLastUpdateTime: async () => 0,
  getLastUpdateTimeSync: () => 0,
  getReadableVersion: () => '1.0.0.1',
  getDeviceType: () => 'Handset',
  isTablet: () => false,
  isPinOrFingerprintSet: async () => false,
  isPinOrFingerprintSetSync: () => false,
  supportedAbis: async () => [],
  supportedAbisSync: () => [],
};

export default DeviceInfo;
